<template>
  <div class="wts-toolbars">
    <!-- LEFT -->
    <div class="wts-toolbars-left">
      <!-- FILTER -->
      <b-button
        id="btnShowFilter"
        size="sm"
        pill
        variant="light"
        class="mx-2"
        style="width: 35px;"
        v-if="!showFilter"
        @click="filter"
      >
        <i class="fa fa-filter"></i>
      </b-button>
    </div>

    <!-- RIGHT -->
    <div class="wts-toolbars-right">
      <!-- ADICIONAR -->
      <b-button
        id="btnAdd"
        size="sm"
        pill
        variant="primary"
        class="mx-2 wts-toolbar-btn"
        :disabled="disabledAdd"
        @click="add"
        v-if="!noInsert"
      >
        <i class="fa fa-plus-circle mx-2"></i>
        <strong class="wts-strong">ADD</strong>
      </b-button>

      <!-- SALVAR -->
      <b-button
        id="btnSave"
        size="sm"
        pill
        variant="primary"
        class="mx-2 wts-toolbar-btn"
        :disabled="disabledSave"
        @click="save"
        v-if="!noModify"
      >
        <i class="fa fa-check-circle mx-2"></i>
        <strong class="wts-strong">SAVE</strong>
      </b-button>

      <!-- CANCELAR -->
      <b-button
        id="btnCancel"
        size="sm"
        pill
        variant="primary"
        class="mx-2 wts-toolbar-btn"
        :disabled="disabledCancel"
        @click="reset"
        v-if="!noInsert"
      >
        <i class="fa fa-undo mx-2"></i>
        <strong class="wts-strong">CANCEL</strong>
      </b-button>

      <!-- EXCLUIR -->
      <b-button
        id="btnDelete"
        size="sm"
        pill
        variant="primary"
        class="mx-2 wts-toolbar-btn"
        :disabled="disabledDelete"
        @click="showRemoveModal"
        v-if="!noDelete"
      >
        <i class="fa fa-trash mx-2"></i>
        <strong class="wts-strong">DELETE</strong>
      </b-button>

      <!-- EXIT -->
      <b-button id="btnClose" pill size="sm" variant="light" class="mx-2" @click="close">
        <i class="fas fa-times"></i>
      </b-button>
    </div>

    <!-- REMOVE MODAL -->
    <b-modal ref="remove-modal" title="Confirmation" centered>
      <div class="mx-2 mt-3 mb-3">
        <strong>Do you want to delete the record?</strong>
        <p class="ml-3 mt-3">ID: {{objProps[`${this.primary_key}`]}}</p>
        <b-container fluid v-if="requiredEndDt">
          <hr />
          <b-row class="mb-1 text-center">
            <b-col>End Date</b-col>
          </b-row>
          <b-row>
            <b-col cols="2"></b-col>
            <b-col>
              <input type="date" class="form-control" v-model="objModal.end_dt" />
            </b-col>
            <b-col cols="2"></b-col>
          </b-row>
        </b-container>
      </div>

      <template v-slot:modal-footer>
        <div class="mr-3">
          <b-button size="sm" pill variant="light" @click="hideRemoveModal">
            <i class="fas fa-times-circle"></i> Cancel
          </b-button>
        </div>
        <div class="ml-3">
          <b-button size="sm" pill variant="primary" @click="confirmRemove">
            <i class="fa fa-check-circle"></i> Confirm
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/** COMPONENTS **/

export default {
  name: "Toolbars",
  /* COMPONENTS IN USE */
  components: {},

  /* PROPS */
  props: {
    objProps: {},
    objPropsData: {},
    urlServices: String,
    primary_key: String,
    nameObjData: String,
    requiredEndDt: Boolean,
    noDelete: Boolean,
    noModify: Boolean,
    noInsert: Boolean
  },

  /* COMPUTED VARIABLES */
  computed: {
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objShared() {
      return this.$store.state.objShared;
    },
    showFilter() {
      return this.$store.state.toolbars.showFilter;
    },
    mq() {
      return this.$mq;
    },
    action() {
      return this.$store.state.action;
    },
    activeSystem() {
      return this.$store.state.activeSystem;
    }
  },
  /* VARIABLES */
  data: function() {
    return {
      disabledAdd: true,
      disabledSave: true,
      disabledCancel: true,
      disabledDelete: true,
      objMerge: {},
      objModal: {},
      objArray: [],
      objArray2: {}
    };
  },
  methods: {
    init() {
      this.objMerge = {};
      this.objModal = {};
      this.$store.commit("setObjShared", {});
      this.$store.commit("setShowGrid", true);
      this.controlButtons("initial");
    },

    isObjectEmpty(obj) {
      for (let x in obj) {
        return false;
      }
      return true;
    },

    controlButtons(typeAction) {
      if (typeAction === "initial") {
        this.disabledAdd = false;
        this.disabledSave = true;
        this.disabledCancel = true;
        this.disabledDelete = true;
      }
      if (typeAction === "add") {
        this.disabledAdd = true;
        this.disabledSave = true;
        this.disabledCancel = false;
        this.disabledDelete = true;
      }
      if (typeAction === "modify") {
        this.disabledAdd = true;
        this.disabledSave = false;
        this.disabledCancel = false;
        this.disabledDelete = false;
      }
      if (typeAction === "reset") {
        this.disabledAdd = false;
        this.disabledSave = true;
        this.disabledCancel = true;
        this.disabledDelete = true;
      }
    },

    filter() {
      this.$store.commit("setShowFilter");
    },

    add() {
      this.$store.commit("setShowGrid", false);
      this.$store.commit("setAction", "add");
    },

    save() {
      this.$store.commit("setShowLoading", true);
      const isEmptyProps = this.isObjectEmpty(this.objProps);
      const isEmptyPropsData = this.isObjectEmpty(this.objPropsData);

      if (isEmptyProps === false || isEmptyPropsData === false) {
        this.objMerge = { ...this.objProps };
        if (this.nameObjData !== null || isEmptyPropsData === false) {
          this.objMerge[`${this.nameObjData}`] = { ...this.objPropsData };
        }
        this.$store.commit("setObjShared", this.objMerge);
      }

      const method = {}.hasOwnProperty.call(
        this.objShared,
        `${this.primary_key}`
      )
        ? "post"
        : "put";
      const apiAction = {}.hasOwnProperty.call(
        this.objShared,
        `${this.primary_key}`
      )
        ? "update"
        : "insert";

      axios[method](
        `${baseApiUrl}:${baseApiPort}/${this.urlServices}/${apiAction}/`,
        this.objShared
      )
        .then(res => {
          this.$store.commit("alert/setShowAlert", true);
          this.$store.commit(
            "alert/setMessage",
            "Request ID: " + res.data[0][`${this.primary_key}`]
          );
          this.$store.commit("alert/setSuccessvariant");
          this.reset();
          this.$store.commit("setShowLoading", false);
        })
        .catch(error => {
          this.$store.commit("alert/setShowAlert", true);
          this.$store.commit("alert/setMessage", error.response.data);
          this.$store.commit("alert/setDangervariant");
          this.$store.commit("setShowLoading", false);
        });
    },

    reset() {
      this.$store.commit("setAction", "reset");
      this.init();
    },

    showRemoveModal() {
      this.$refs["remove-modal"].show();
    },

    hideRemoveModal() {
      this.$refs["remove-modal"].hide();
      this.objModal = {};
    },

    confirmRemove() {
      this.remove();
      this.hideRemoveModal();
    },

    remove() {
      this.$store.commit("setShowLoading", true);
      const isEmpty = this.isObjectEmpty(this.objProps);
      const param = {};

      if (isEmpty === false) {
        this.$store.commit("setObjShared", this.objProps);
        param[`${this.primary_key}`] = this.objProps[`${this.primary_key}`];

        if (this.requiredEndDt === true) {
          param[`${this.nameObjData}`] = { ...this.objModal };
        }

        const method = this.requiredEndDt ? "post" : "delete";
        const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/delete/`;

        axios[method](url, this.requiredEndDt ? param : { params: param })
          //axios.delete(url, { params: param })
          .then(() => {
            this.$store.commit("alert/setShowAlert", true);
            this.$store.commit("alert/setMessage", "");
            this.$store.commit("alert/setSuccessvariant");
            this.reset();
            this.$store.commit("setShowLoading", false);
          })
          .catch(error => {
            this.$store.commit("alert/setShowAlert", true);
            this.$store.commit("alert/setMessage", error.response.data);
            this.$store.commit("alert/setDangervariant");
            this.$store.commit("setShowLoading", false);
          });
      }
    },

    close() {
      if (this.activeSystem === "Streamline") this.$router.push({ name: "home" });
      if (this.activeSystem === "BPM") this.$router.push({ name: "bpm_home" });
    }
  },

  watch: {
    mq() {
      if (this.mq === "md" || this.mq === "sm" || this.mq === "xs") {
        this.$store.commit("setShowFilter", false);
      } else {
        this.$store.commit("setShowFilter", true);
      }
    },
    action() {
      //if (this.urlServicesStore === this.urlServices) {
      this.controlButtons(this.action);
      //}
    },
    objPropsData() {
      if (this.action === "add") {
        this.emptyPropsData = this.isObjectEmpty(this.objPropsData);
        if (this.isObjectEmpty(this.objPropsData) === false) {
          this.controlButtons("modify");
        }
      }
    }
  },

  created() {
    this.init();
  },
  updated() {
    if (this.action === "add") {
      this.emptyPropsData = this.isObjectEmpty(this.objPropsData);
      if (this.isObjectEmpty(this.objPropsData) === false) {
        this.controlButtons("modify");
      }
    }
  },
  beforeDestroy() {
    this.$store.commit("setAction", "none");
    this.$store.commit("alert/setShowAlert", false);
  }
};
</script>